




































































































































































import {Component, Vue} from 'vue-property-decorator';
import Smooth from '../../utils/smooth'

@Component({
    components: {},
    data() {
        return {
            laptopImg: require('../../assets/bg.png'),
            mobileImg: require('../../assets/first_view_image_mobile_1.png'),
            responsive: false,
        }
    },
    mounted(){
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted);
    },
    methods:{
        onResponsiveInverted() {
            // @ts-ignore
            this.responsive = window.innerWidth < 768;
            // @ts-ignore
            this.onSetMetaViewPort();
        },
        scrollToSample() {
            Smooth.scrollToDiv(document.getElementById("sample"));
        },
        onSetMetaViewPort() {
            let contentViewport = (screen.width >= 768  && screen.width <= 1024) ?
                'width=1200' :
                'width=device-width, initial-scale=1.0';
            const meta = document.querySelector('meta[name="viewport"]');
            meta.setAttribute('content',contentViewport);
        }
    }
})
export default class Header extends Vue {

}
